export default [
  {
    path: 'layout',
    component: () => import('./MenuLayout'),
    children: [
      {
        path: '/',
        component: () => import('./MenuLayoutTabs'),
        name: 'menuLayout'
      },
      {
        path: 'generate',
        component: () => import('./layout-generate/LayoutGenerate'),
        name: 'menuLayoutGenerate'
      }
    ]
  }
]
